import { render, staticRenderFns } from "./Usages.vue?vue&type=template&id=2c399f58"
import script from "./Usages.vue?vue&type=script&lang=js"
export * from "./Usages.vue?vue&type=script&lang=js"
import style0 from "./Usages.vue?vue&type=style&index=0&id=2c399f58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports